<template>
  <footer class="footer">
    <div class="footer-content flex wh1200">
      <div class="footer-l">
        <div class="links">
          <span style="font-size: 18px">友情链接：</span>
          <a href="https://hrss.henan.gov.cn/" target="_blank">河南省人力资源和社会保障厅</a>
        </div>
        <p>版权所有 &nbsp;&nbsp; 河南省劳动关系权益保障联动平台 &nbsp;&nbsp; 河南省人力资源和社会保障厅主办</p>
        <p></p>
        <p>办公时间：周一至周五上午：9:00-12:00，下午：13:00-17:00（7月1日至8月31日下午14:00-17:00，法定节假日按照国家规定执行）</p>
        <p>邮编：450000 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;网址：https://hrss.henan.gov.cn/</p>
        <p></p>
      </div>
      <!-- <div class="footer-r flex">
        <div class="code">
          <img src="@/assets/images/ldzc-gzry.jpg" alt="">
          <p>微信订阅号</p>
        </div>
        <div class="code">
          <img src="@/assets/images/ldzc-gzry.jpg" alt="">
          <p>微信服务号</p>
        </div>
      </div> -->
    </div>
    <div class="footer-bottom">
      <a href="http://bszs.conac.cn/sitename?method=show&id=0B04D0306D1304E7E053012819AC16E8" target="_blank" rel="noopener noreferrer">
        <img style="height: 60px;" src="https://file.henan.gov.cn/4500000013/img/newsimg1.jpg" alt="">
      </a>
      
      <span>政府网站标识码:4100000037</span>
      工信部备案号：<a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备14002359号-5</a> <img src="@/assets/images/footer-gwab-pic.png" alt=""> 郑公备:41010702002429  | Copyright @2024 hrss.henan.gov.cn. All Rights Reserved.
      <a href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=4100000037&url=http%3A%2F%2Fhrss.henan.gov.cn%2F" target="_blank" rel="noopener noreferrer">
        <img style="height: 50px;" src="https://zfwzgl.www.gov.cn/exposure/images/jiucuo.png?v=4100000037" alt="">
      </a>
    
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped lang="scss">
.footer {
  font-size: 14px;
  color: #fff;

  .footer-content {
    // padding: 25px 0;
    text-align: left;
    justify-content: space-between;

    .footer-l {
      background: url(@/assets/images/fb.png) 60px center no-repeat;
    }

    p {
      margin: 10px 0;
      color: #dbdbdb;
    }

    .links {
      border-bottom: #424242 solid 1px;
      padding: 18px 0 18px 0;
      width: 900px;
      margin-bottom: 20px;
    }

    .footer-r {
      justify-content: space-evenly;
      align-items: center;

      .code {
        margin-right: 10px;
        text-align: center;

        img {
          width: 80px;
        }
      }
    }
  }

  .footer-bottom {
    width: 1200px;
    margin: auto;
    text-align: center;
    color: #808080;
    border-top: 1px solid #424242;
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 10px;
  }
}
</style>
